// Matches the Certifications section above it
.support-section {
  margin-top: clamp(48px, 5vw, 72px);
  padding-top: clamp(24px, 2.5vw, 32px);
  border-top: 1px solid #f1f1f1;
}

.support-title {
  margin: 0;
  color: #160004;
  font-size: clamp(22px, 2.3vw, 30px);
  font-family: Red Rose-SemiBold;
  text-transform: uppercase;
  line-height: 1.1;
}

.support-cards {
  margin-top: 28px;
}
